import {
	browserBootstrapFromGlobal,
	connectEmulators,
	initFirebaseClient,
} from "@momo/firebase-client";
import { isOrganizationId } from "./organization-id.ts";

const bootstrap = browserBootstrapFromGlobal();
const client = initFirebaseClient(bootstrap, { emulator: import.meta.env.DEV });
export const emulatorEndpoints = import.meta.env.DEV
	? connectEmulators(client)
	: undefined;
export const { app, auth, db, storage, functions } = client;
export const defaultHostingOrigin = bootstrap.defaultHostingOrigin;
const pathOrg = /^\/o\/([^/]+)(?:\/|$)/.exec(window.location.pathname)?.[1];
const platform = true;
let resolved = pathOrg ? decodeURIComponent(pathOrg) : "";
export let organizationError = "";
if (resolved && !isOrganizationId(resolved)) {
	resolved = "";
	organizationError = "This organization address is invalid.";
}
// This document is one immutable organization context. Switching saves the
// selection, then navigates a new document, cancelling every old UI listener.
export const workspaceId = resolved;
export const organizationPath =
	platform && workspaceId ? `/o/${encodeURIComponent(workspaceId)}` : "";
